import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/a11y';
import 'swiper/css/navigation';

import { A11yMessages } from '../utils/swiper.js';

export default function () {
  const pageLang = document.querySelector('html').getAttribute('lang') || 'en';

  const cardsGridEl = document.querySelectorAll('.swiper.cards-grid');

  cardsGridEl.forEach(element => {
    const spaceBetween = element.getAttribute('data-space-between') || 16;
    const width = element.getAttribute('data-width') || 300;
    try {
      const swiperCardsGrid = new Swiper(element, {
        a11y: A11yMessages(pageLang),
        spaceBetween: spaceBetween,
        width: width,
        navigation: {
          nextEl: ".swiper-button-next-custom",
          prevEl: ".swiper-button-prev-custom"
        },
        modules: [Navigation, A11y]
      });
    } catch (error) {
      console.error('Error initializing Swiper:', error);
    }
    
  });
}
